import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDeleteFacility, useGetFacilityPagesList } from "../../../../api/facility";
import { useGetCountries } from "../../../../api/static-data";
import { errorView, successMessage } from "../../../../helpers/ErrorHandler";

export const useFacilityListViewModel = () => {
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleEditModal, setVisibleEditModal] = useState(false);
  const [visibleDetailsModal, setVisibleDetailsModal] = useState(false);
  const [showDeleteFacilityModal, setShowDeleteFacilityModal] = useState(false);
  const [viewFacilityData, setViewFacilityData] = useState();
  const [editFacilityData, setEditFacilityData] = useState();
  const [deleteFacilityData, setDeleteFacilityData] = useState<any>({});
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [pageLimit] = useState<any>(10);
  const [filteredFacilityTypes, setFilteredFacilityTypes] = useState<string[]>([]);

  const { register, watch } = useForm();
  const [searchFacility] = watch(["searchFacility"]);

  const {
    data: facilityList,
    isLoading: isFacilityListLoading,
    refetch
  } = useGetFacilityPagesList(pageNumber, pageLimit, searchFacility, filteredFacilityTypes);

  const { isLoading: editFacilityLoading, mutate: deleteFacility } = useDeleteFacility();

  const { data: countriesData, isLoading: isCountriesDataLoading } = useGetCountries();

  const refetchWithFilters = (newFacilityTypeIds: string[]) => {
    setFilteredFacilityTypes(newFacilityTypeIds);
  };

  const handlePagination = (currentPage: any) => {
    setPageNumber(currentPage);
  };

  const getFacilityDetails = (selectedFacility: any) => {
    setViewFacilityData(selectedFacility);
    setEditFacilityData(selectedFacility);
    setVisibleDetailsModal(true);
  };

  const handleFacilityDelete = (detailsToDelete: any) => {
    setDeleteFacilityData(detailsToDelete);
    setShowDeleteFacilityModal(true);
  };

  const getFacilityForEditDetails = (selectedFacility: any) => {
    setEditFacilityData(selectedFacility);
    setVisibleEditModal(true);
  };

  const enableEditFacility = () => {
    setVisibleDetailsModal(false);
    setVisibleEditModal(true);
  };

  const deleteFacilityDetails = (data: any) => {
    deleteFacility(data, {
      onSuccess: () => {
        setVisibleModal(false);
        successMessage("Facility removed successfully");
        refetch();
      },
      onError: (error: any) => {
        errorView(error);
      }
    });
  };

  const facilityRows = facilityList?.result ?? [];
  const totalCount = facilityList?.total || 0;
  const totalPages = Math.ceil(totalCount / pageLimit) || 1;
  const rangeStart = totalCount === 0 ? 0 : (pageNumber - 1) * pageLimit + 1;
  const rangeEnd = Math.min(pageNumber * pageLimit, totalCount);
  const isTableLoading = isFacilityListLoading || isCountriesDataLoading;

  return {
    visibleModal,
    setVisibleModal,
    visibleEditModal,
    setVisibleEditModal,
    visibleDetailsModal,
    setVisibleDetailsModal,
    showDeleteFacilityModal,
    setShowDeleteFacilityModal,
    viewFacilityData,
    editFacilityData,
    setEditFacilityData,
    deleteFacilityData,
    setDeleteFacilityData,
    register,
    refetch,
    countriesData,
    editFacilityLoading,
    facilityRows,
    totalCount,
    totalPages,
    rangeStart,
    rangeEnd,
    pageNumber,
    isTableLoading,
    refetchWithFilters,
    handlePagination,
    getFacilityDetails,
    handleFacilityDelete,
    getFacilityForEditDetails,
    enableEditFacility,
    deleteFacilityDetails
  };
};
